<span dropdown (onShown)="onShown()" (onHidden)="onHidden()" (isOpenChange)="isOpenChange()">
  <a href dropdownToggle (click)="false"><i class="fas fa-trash" [ngClass]="{'text-white': type=='upload'}"></i></a>
    <ul *dropdownMenu class="dropdown-menu">
      <li *ngFor="let choice of items">
        <a class="dropdown-item" href="javascript:void(0);" (click)="onItemClick(choice)">{{choice}}</a>
      </li>
    </ul>
</span>
